var map = {
	"./balloons.json": "8Vop",
	"./bear.json": "bZGZ",
	"./chocolate.json": "Nk+5",
	"./envelope.json": "pjTy",
	"./flowers.json": "ageB",
	"./giftbox.json": "2EvM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "idke";


//////////////////
// WEBPACK FOOTER
// ./src/assets/json ^\.\/.*\.json$
// module id = idke
// module chunks = 1